module.exports = __webpack_public_path__ + "static/media/yin-yang.12df2abb.svg";